<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-contacts">
        <ul class="mc-contacts__list">
          <li class="mc-contacts__item mc-contacts-item">
            <div class="mc-contacts-item__title">
              По вопросам о товарах и заказах
            </div>
            <ul class="mc-contacts-item__list">
              <li class="mc-contacts-item__line">
                <a @click="tel_open('+78005009087')">
                  8 (800) 500 90 87
                </a>
              </li>
              <li class="mc-contacts-item__line">
                бесплатные звонки из регионов
              </li>
              <li class="mc-contacts-item__line">
                ежедневно с 9.00 до 21.00 по Мск
              </li>
              <li class="mc-contacts-item__line">
                <a @click="email_open('info@fashionstore.ru')">
                  info@fashionstore.ru
                </a>
              </li>
              <li class="mc-contacts-item__line">
                <a href="https://t.me/+79313896198">
                  Telegram
                </a>
              </li>
              <li class="mc-contacts-item__line">
                <a href="https://vk.com/fashionstore_ru">
                  VK
                </a>
              </li>
            </ul>
          </li>
          <li v-if="false" class="mc-contacts__item mc-contacts-item">
            <div class="mc-contacts-item__title">
              По вопросам качества услуг
            </div>
            <ul class="mc-contacts-item__list">
              <li class="mc-contacts-item__line">
                <a @click="email_open('cs@mcbuy.ru')">
                  cs@mcbuy.ru
                </a>
              </li>
            </ul>
          </li>
          <li v-if="false" class="mc-contacts__item mc-contacts-item">
            <div class="mc-contacts-item__title">
              По вопросам сотрудничества
            </div>
            <ul class="mc-contacts-item__list">
              <li class="mc-contacts-item__line">
                <a @click="email_open('pr@mcbuy.ru')">
                  pr@mcbuy.ru
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <div class="mc-contacts__requisites">
          <div class="mc-contacts__requisites-title">
            Реквизиты
          </div>
          <dl class="mc-contacts__requisites-list">
            <div class="mc-contacts__requisites-item">
              <dd class="mc-contacts__requisites-value">
                ИП Инкина Марина Викторовна
              </dd>
            </div>
            <div class="mc-contacts__requisites-item">
              <dt class="mc-contacts__requisites-term">
                ИНН
              </dt>
              <dd class="mc-contacts__requisites-value">
                780525852478
              </dd>
            </div>
            <div class="mc-contacts__requisites-item">
              <dt class="mc-contacts__requisites-term">
                ОГРНИП
              </dt>
              <dd class="mc-contacts__requisites-value">
                315784700185989
              </dd>
            </div>
            <div class="mc-contacts__requisites-item">
              <dt class="mc-contacts__requisites-term">
                Юридический адрес
              </dt>
              <dd class="mc-contacts__requisites-value">
                196066, г. Санкт-Петербург, ул. Краснопутиловская, дом 108, кв. 56
              </dd>
            </div>
            <div class="mc-contacts__requisites-item">
              <dt class="mc-contacts__requisites-term">
                Адрес для корреспонденции
              </dt>
              <dd class="mc-contacts__requisites-value">
                191186, г. Санкт-Петербург, Итальянская ул. д. 2 пом. 9Н
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import urlopen from "@/mixin/urlopen.vue";

export default {
  mounted() {

  },
  mixins: [urlopen],
  components: {},
  methods: {
  },
}
</script>

